import script from "./JourneySection.vue?vue&type=script&setup=true&lang=js"
export * from "./JourneySection.vue?vue&type=script&setup=true&lang=js"

import "./JourneySection.vue?vue&type=style&index=0&id=6c39a535&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c39a535"]])

export default __exports__